import React, { useState } from 'react';
import { Box } from '@mui/material';
import Navbar from './Navbar';
import Sidebar from './Sidebar';
import { Outlet } from 'react-router-dom';
import Footer from '../../footer';

const DashboardLayout: React.FC = () => {
  const [isCollapsed, setIsCollapsed] = useState(false);

  let colors = {
    sidebarBg: "linear-gradient(135deg, #000080 0%, #000080 100%)",
    contentBg: "#f5f5f5 ",
    accent: "#000080",
  };

  const toggleSidebar = () => {
    setIsCollapsed(prev => !prev);
  };

  return (
    <Box sx={{ display: 'flex' }}>
      {/* Sidebar Component */}
      <Sidebar
        isCollapsed={isCollapsed}
        sx={{
          transition: 'transform 0.3s ease-in-out',
          transform: isCollapsed ? 'scale(0)' : 'scale(1)',
        }}
        colors={colors}
      />

      {/* Main Content Area */}
      <Box sx={{ flexGrow: 1, display: 'flex', flexDirection: 'column' }}>
        {/* Navbar */}
        <Navbar 
          onMenuClick={toggleSidebar}
          isSidebarCollapsed={isCollapsed}
          colors={colors}
        />

        {/* Page Content */}
        <Box
          sx={{
            flexGrow: 1,
            overflowY: "auto",
            backgroundColor: colors.contentBg,
            minHeight: 'calc(100vh - 64px)', // Subtract navbar height
          }}
        >
          <div style={{ padding: 24 }}>
            <Outlet />
          </div>
          <Footer />
        </Box>
      </Box>
    </Box>
  );
};

export default DashboardLayout;
